import { render, staticRenderFns } from "./ChildQuestions.vue?vue&type=template&id=f012abb6&scoped=true&"
import script from "./ChildQuestions.vue?vue&type=script&lang=js&"
export * from "./ChildQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f012abb6",
  null
  
)

export default component.exports